<template>
    <div>
        <buttonlist ref="SetBtn" @help="help" @search="search" @exps="exps"></buttonlist>
        <div style="width:100%">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[112]') }}</td>
                    <td style="width:150px;">
                        <routejump :urlNo="12">
                        <el-input  type="text" v-model="dataDetail.partcode"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                        </el-input>
                        </routejump>
                    </td>
                    <td style="width:60px">{{ $t('getapi[149]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetail.partversion" :disabled="true"></el-input>
                    </td>
                </tr>
            </table>
            <el-table
                    id="xpane-0"
                    :data="dataDetail.Lists"
                    ref="singleTable"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="partcode" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[113]')"></el-table-column>
                <el-table-column prop="Extra_qty" :label="$t('getapi[7196]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.Extra_qty | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="MOQ" label="MOQ" align="right">
                    <template slot-scope="scope">
                        {{scope.row.MOQ | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="Safety_Stock" :label="$t('getapi[2548]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.Safety_Stock | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column prop="package_qty" :label="$t('getapi[164]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.package_qty | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="calc_date" :label="$t('getapi[7197]')"></el-table-column>
                <el-table-column prop="trans_qty" :label="$t('getapi[7198]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.trans_qty | thousandth}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/MRP/CountView/GetMOQPartPopupList'" @callback="getpart" ref="part"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_moqlist',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    partcode: '',
                    partversion: '',
                    Lists: [],
                },
                scrollTop:0,
            };
        },
        watch: {
            'dataDetail.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let parm = {
                part_code: '',
                part_version: ''
            }
            that.getDetail(parm)
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6604]"),'MRP');
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,export');
            },
            selectpart(row){
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                console.log(data)
                that.dataDetail.partcode = data.partcode
                that.dataDetail.partversion = data.partversion
                let parm = {
                    part_code: data.partcode,
                    part_version: data.partversion
                }
                that.getDetail(parm)
            },
            search(){
                let that = this
                that.dataDetail.partcode = ''
                that.dataDetail.partversion = ''
                let parm = {
                    part_code: '',
                    part_version: ''
                }
                that.getDetail(parm)
            },
            getDetail(parm){
                let that = this
                that.$http.urlpost('/MRP/CountView/GetMOQList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.Lists = res.DataContent;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            exps(){
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/MRP/CountView/GetMOQListToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
